// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"5ae2d03e","712":"4280a944"}[chunkId] + ".chunk.js";
};